import './index.scss';
import React, {useState, useRef, useEffect} from "react";
import Menu from "./Menu/index";
import { useSelector } from 'react-redux';
import { selectReduxSlice } from '../../Store/store';
import { fetchAudio, fetchImage } from '../nonUIFuncs';
import { FontAwesomeIcon as FAIcon } from "@fortawesome/react-fontawesome";
import { faForward, faBackward, faPlay, faPause, faArrowRotateForward, faArrowRightFromBracket } from "@fortawesome/free-solid-svg-icons";


const Story = ({
  currentPage,
  ended,
  currentAudio,
  shouldAutoPlay,
  setShouldAutoPlay,
  backToMenu,
  nextPage,
  prevPage,
  changePage,
}) => {
  const [languageToShow, setLanguageToShow] = useState("fullSentence");
  useEffect(() => {changePage()}, []);
  console.log(currentPage);
  return (
    <div className="storybook_corner_container">
      <div
        className={
          currentPage.isLandscape === false
            ? "storybook_corner_page"
            : "storybook_corner_page_landscape"
        }
        style={{ backgroundImage: `url(${fetchImage(currentPage.App_Art)})` }}
      >
        <div
          className="storybook_corner_sentence"
          onClick={() =>
            setLanguageToShow(
              languageToShow === "fullSentence" ? "English" : "fullSentence"
            )
          }
        >
          {currentPage[languageToShow]}
        </div>
      </div>
      <div className="storybook_corner_buttons_container">
        <div
          className="storybook_corner_button hovercursor"
          onClick={backToMenu}
        >
          <FAIcon
            style={{ transform: "scaleX(-1)" }}
            icon={faArrowRightFromBracket}
            size="xl"
          />
        </div>
        <div className="storybook_corner_button hovercursor" onClick={prevPage}>
          <FAIcon icon={faBackward} size="xl" />
        </div>
        {currentAudio?.paused ? (
          <div
            className="storybook_corner_button hovercursor"
            onClick={() => changePage({ newPage: currentPage })}
          >
            <FAIcon icon={faPlay} size="xl" />
          </div>
        ) : (
          <div
            className="storybook_corner_button hovercursor"
            onClick={() => currentAudio.pause()}
          >
            <FAIcon icon={faPause} size="xl" />
          </div>
        )}
        <div
          onClick={() => setShouldAutoPlay(!shouldAutoPlay)}
          className="storybook_corner_button hovercursor"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <FAIcon
            style={{ position: "absolute" }}
            icon={faArrowRotateForward}
            size="xl"
          />
          <FAIcon style={{ position: "absolute" }} icon={faPlay} size="2xs" />
        </div>
        <div className="storybook_corner_button hovercursor" onClick={nextPage}>
          <FAIcon icon={faForward} size="xl" />
        </div>
      </div>
    </div>
  );
};

const StoryBookCorner = ({config}) => {
  const reduxState = useSelector(selectReduxSlice);
  const reduxStateRef = useRef(reduxState);
  const currentPageRef = useRef({});
  const currentAudioRef = useRef(null);
  const shouldAutoPlayRef = useRef(false);
  const [showMenu, setShowMenu] = useState(true);
  const [chosenBook, setChosenBook] = useState([]);
  const [currentPage, setCurrentPage] = useState({});
  const [ended, setEnded] = useState(false);
  const [shouldAutoPlay, setShouldAutoPlay] = useState(false);
  const [currentAudio, setCurrentAudio] = useState(null);
  reduxStateRef.current = reduxState;
  currentPageRef.current = currentPage;
  currentAudioRef.current = currentAudio;
  shouldAutoPlayRef.current = shouldAutoPlay;
  const stopAudio = () => {
    if (currentAudioRef.current !== null) {
      currentAudioRef.current.pause();
      currentAudioRef.current.currentTime = 0;
    }
  };
  const changePage = ({newPage}) => {
    console.log(newPage);
    let newAudioFile = newPage !== undefined ? newPage.App_Audio : currentPageRef.current.App_Audio;
    stopAudio();
    if (newAudioFile.length > 0) {
      let newAudio = new Audio(`${fetchAudio(newAudioFile)}`);
      setCurrentAudio(newAudio);
      setEnded(false);
      newAudio.play();
      newAudio.onended = onEnded;
    }
  };
  const backToMenu = () => {
    stopAudio();
    setShowMenu(true);
    setChosenBook([]);
    setCurrentPage({});
    setEnded(false);
    setShouldAutoPlay(false);
  };
  const nextPage = () => {
    let newPage = chosenBook.find(
      (page) => Number(page.page) === Number(currentPageRef.current.page + 1)
    );
    if (newPage === undefined) {
      backToMenu();
      setCurrentPage({});
    } else {
      setCurrentPage(newPage);
      changePage({newPage: newPage});
    }
  };
  const prevPage = () => {
    let newPage = chosenBook.find(
      (page) => Number(page.page) === Number(currentPageRef.current.page - 1)
    );
    if (newPage === undefined) {
      backToMenu();
      setCurrentPage({});
    } else {
      setCurrentPage(newPage);
      changePage({newPage: newPage});
    }
  };
  const onEnded = () => {
    setEnded(true);
    if (shouldAutoPlayRef.current) {
      nextPage();
    } else {

    }
  };
  return (
    <div className="storybook_corner_background">
      <div className="storybook_corner_safe_view_area">
        {showMenu ? (
          <Menu
            setShowMenu={setShowMenu}
            setChosenBook={setChosenBook}
            setCurrentPage={setCurrentPage}
          />
        ) : (
          <Story
            currentPage={currentPageRef.current}
            ended={ended}
            currentAudio={currentAudioRef.current}
            shouldAutoPlay={shouldAutoPlayRef.current}
            setShouldAutoPlay={setShouldAutoPlay}
            nextPage={nextPage}
            prevPage={prevPage}
            backToMenu={backToMenu}
            changePage={() => changePage(currentPageRef.current)}
          />
        )}
      </div>
    </div>
  );
};

export default StoryBookCorner;